<div class="front-change-status-section">
    <form [formGroup]="formStatus">
        <div class="form-group">
            <label class="title-status">{{ "status" | lang }}</label>
            <div class="d-flex m-0 p-0 status-selector">
                <app-dropdown-selector
                    class="ads-status-selector"
                    formControlName="selectedStatus"
                    *ngIf="availableStatus"
                    [label]="' '"
                    placeholder="{{ 'select-status' | lang }}"
                    [isDisabled]="false"
                    [items]="availableStatus"
                    bindLabel="name"
                    bindValue="statusId"
                    [multiselect]="false"
                    [allSelectedOption]="false"
                    [treeViewSelect]="true"
                    (ngModelChange)="selectStatus($event)"
                ></app-dropdown-selector>
            </div>

            <label class="title-comment">{{ "comment" | lang }}</label>
            <div class="comment-box">
                <textarea
                    class="input-comment"
                    #commentText
                    maxlength="500"
                    rows="10"
                    cols="50"
                    placeholder="{{ 'add_comment' | lang }}"
                    type="text"
                    formControlName="comment"
                ></textarea>
                <span class="countLetter">{{
                    500 - (commentText.value.length || 0)
                }}</span>
            </div>


            <div class="d-flex align-items-center justify-content-between w-100">
                <div *ngIf="hasMessage; else noMessage">
                    <div [ngClass]="{'message-error': hasError, 'message-success': !hasError}">
                        <img appImageSelector [imageKey]="hasError ? 'error-circle' : 'check-circle'" imageType="icon" alt="mt" />{{ message }}
                    </div>
                </div>
                <ng-template #noMessage>
                    <div>
                    
                    </div>
                </ng-template>

                <div class="buttons d-flex gap-2">
                    <app-button
                        text="cancel"
                        class="cancel shadowed"
                        (clickHandler)="clear()"
                    ></app-button>
                    <app-button
                        text="change status"
                        [disabled]="disabledChangeStatus"
                        class="action shadowed"
                        (clickHandler)="updateStatus()"
                    ></app-button>
                </div>
            </div>
        </div>
    </form>
</div>
